import { apiClient } from '../lib/api-client';
import type {
  PagedResultDto,
  ProductAdminDto,
  ProductAdminQueryDto,
  SetProductStatusDto,
} from '../types/admin-api';

export const productService = {
  getAll: async (query: ProductAdminQueryDto = {}) => {
    const response = await apiClient.get<PagedResultDto<ProductAdminDto>>(
      '/products',
      { params: query }
    );
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<ProductAdminDto>(`/products/${id}`);
    return response.data;
  },

  setStatus: async (id: string, data: SetProductStatusDto) => {
    const response = await apiClient.put(`/products/${id}/status`, data);
    return response.data;
  },
};
